var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Multiselect", {
    attrs: {
      value: _vm.selectedTimezone,
      options: _vm.options,
      multiple: false,
      "group-select": false,
      placeholder: _vm.placeholder,
      "group-values": "regions",
      "group-label": "continent",
      "track-by": "timezoneId",
      label: "label",
      "open-direction": "above"
    },
    on: { input: _vm.change }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }